import { render } from "./Notifier.vue?vue&type=template&id=c924e712&scoped=true&ts=true"
import script from "./Notifier.vue?vue&type=script&lang=ts"
export * from "./Notifier.vue?vue&type=script&lang=ts"

import "./Notifier.vue?vue&type=style&index=0&id=c924e712&scoped=true&lang=scss"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c924e712"]])

export default __exports__